module.exports = __webpack_public_path__ + "img/logo_navbar.7eff5ac7.png";